import { useMemo } from 'react';
import { IQueryLike } from '../../components/QueriesLoaded';

export const useQueriesFailure = (queries: IQueryLike<any>[]) => {
  return useMemo(() => {
    return queries.every((p) => p.isError);
  }, [queries]);
};
